import * as R from "ramda";

export default function transformDataCenterData(data) {
  const { dataPoints, locations } = data;

  const locationLookup = R.indexBy(R.prop("id"), locations);

  const joinedData = R.compose(
    R.sortBy(R.prop("year")),
    R.map((dataPoint) => {
      const location = locationLookup[dataPoint.location];

      // this is the shape the legacy code is expecting
      return {
        name: location.name,
        code: location.fips,
        total: dataPoint.value,
        year: Number(dataPoint.timeFrame),
      };
    }),
  )(dataPoints);

  return joinedData;
}
